module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"see_all_reviews":"すべての商品レビューを見る","create_review":"商品レビューを作成する"}}')
  delete Component.options._Ctor
}
